import { createFileRoute } from '@tanstack/react-router';

import { ActivityPage } from './ActivityPage';

export const Route = createFileRoute('/_protected/_consumer/activity/')({
  component: ActivityPage,
});
